'use strict';

export { default } from './hotdamnbar.container';